export default {
    add: 'ALERT_ADD',
    clear: 'ALERT_CLEAR',
    remove: 'ALERT_REMOVE',
    modal: 'ALERT_MODAL',
    modalClose: 'ALERT_MODAL_CLOSE',
    decreaseDuration: 'ALERT_DECREASE_DURATION',
};
